import { createUrl, toBlob } from "components/Environment/helpers";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { downloadFileFromURL } from "utils/file";

type DownloadLogsButtonProps = {
  fileName: string;
  href: string;
};

const DownloadFileButton = ({ href, fileName }: DownloadLogsButtonProps) => {
  const downloadLogs = () => {
    const blob = href ? toBlob(href) : undefined;

    if (blob) {
      downloadFileFromURL(createUrl(blob), fileName);
    }
  };

  return <DropdownMenuItem onAction={downloadLogs}>Download</DropdownMenuItem>;
};

export default DownloadFileButton;
